import { Buffer } from "buffer"

export const decodeQRCode = (
  encoded: string
): {
  uuid: string
  type: "unknown" | "worker" | "truck" | "cart" | "load"
} => {
  const decoded = Buffer.from(encoded, "base64").toString("hex")

  const version = Number(decoded.slice(0, 1))

  let uuid: string, type: "unknown" | "worker" | "truck" | "cart" | "load"
  switch (version) {
    case 0:
      uuid = `${decoded.slice(1, 9)}-${decoded.slice(9, 13)}-${decoded.slice(
        13,
        17
      )}-${decoded.slice(17, 21)}-${decoded.slice(21, -1)}`

      switch (decoded.slice(-1)) {
        case "0":
          type = "worker"
          break

        case "1":
          type = "truck"
          break

        case "2":
          type = "cart"
          break

        case "3":
          type = "load"
          break

        default:
          throw Error(`QR 타입 에러 - encoded: ${encoded}\ndecoded: ${decoded}`)
      }

      break

    default:
      throw Error(
        `QR 버전(${version}) 에러 - \nencoded: ${encoded}\ndecoded: ${decoded}`
      )
  }

  return { uuid, type }
}
